const billingMethodType = {
  ClientBilling: 1,
  IndividualBilling: 2
}

export default billingMethodType;